module.exports = __webpack_public_path__ + "media/img/frontend_application/country/sg-3d0b939434bbfb55ff93810348a43209.jpg";